<template>
  <div class="account tableStyle">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" size="small">
          <el-form-item label="类型：" class="screen">
              <el-select v-model="queryForm.type" placeholder="请选择类型" @change="handleSelectCompany(queryForm.type,'query')">
                <el-option label="厂商" :value="1"></el-option>
                <el-option label="物业" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="所属厂商/物业：" class="screen">
            <el-select v-model="queryForm.cid" placeholder="请选择" @change="getAllStation" @click.native="!queryForm.type?$message.error('请先选择类型'):''" :disabled="!queryForm.type" filterable>
              <el-option v-for="(item, index) in allManufacturerSearch" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：" class="screen">
            <el-select v-model="queryForm.status" placeholder="请选择" @change="getTableList('query')">
              <el-option label="禁止" :value="0"></el-option>
              <el-option label="激活" :value="1"></el-option>
              <!-- 状态 收款账户激活状态，0禁止，1激活 -->
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getTableList('query')">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>


    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>        
        <el-table-column prop="payee_name" label="账户名称" align="center"></el-table-column>
        <el-table-column prop="payee_account" label="账户号码" align="center"></el-table-column>
        <el-table-column prop="bank_name" label="开户行" align="center"></el-table-column>
        <el-table-column prop="swift_code" label="开户行号" align="center"></el-table-column>
        <el-table-column prop="status" label="激活状态" align="center">
          <template slot-scope="scope">
           {{scope.row.status == 1 ? '已激活' : '未激活'}}
          </template>
        </el-table-column>

        <el-table-column label="物业/厂商名称" align="center">
          <template slot-scope="scope">
           {{scope.row.company.name}}
          </template>
        </el-table-column>
        <el-table-column label="负责人" align="center">
          <template slot-scope="scope">
           {{scope.row.company.legal_name}}
          </template>
        </el-table-column>
        <el-table-column label="负责人电话" align="center">
          <template slot-scope="scope">
           {{scope.row.company.legal_tel}}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="handleStatus(scope.row)" v-if="scope.row.status !== 1">激活</el-button>
            <el-button type="primary" plain size="mini" @click="handleStatus(scope.row)" v-if="scope.row.status === 1">禁用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pageFoot flex">
      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="queryForm.size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>

    


    
  </div>
</template>
<script>
export default {
  data() {
    return {
      size: 20,
      page: 1,
      total: 0,

      queryForm:{
        page: 1,
        size: 20,
        type:null,
        cid:'', 
        status:'',


      },
      
      //商户提现详情
      detail:{
        form_id:'',
        list:{
          process:[],
          status_str:'',
          company:{},
          pay_id:'',
          acc_bankcode:'',
          acc_bankno:'',
          amount:'',
          bank_fee:'',
          trig_time:'',
          note:'',
        }

      },
      tableData: [],
      dialogVisible: false,


      allManufacturerSearch:[], //搜索
      // allManufacturer: [],
      allStation: [],
      addStations: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
        this.getTableList();
        // this.getAllManufacturer(); //所有厂商物业列表
    },
    // 获取table
    getTableList(type){
      if(type === 'query'){
        this.queryForm.page = 1;
      }
      let params = {
        page: this.queryForm.page,
        size: this.queryForm.size,
        query_columns: {            
          cid: this.queryForm.cid,  //物业、商家id
          status:this.queryForm.status,  
        }
      };
      this.$api.companyBankList(params).then(res=>{
          if (res.code === 200) {
              this.total = res.data.count;
              this.tableData = res.data.list;
              this.statistics = res.data.statistics; //统计
          } else {
            return this.$message.error(res.msg);
          }
      });
    },


    //选择物业厂商
    handleSelectCompany(type,str){
      if(str==='query'){        
        this.queryForm.cid = ''; 
        this.allManufacturerSearch = [];
      }
     
      // if(str==='dialog'){
      //   this.addForm.cid = '';
      //   this.allManufacturer = [];
      // }
      
      
      this.getAllManufacturer(type,str);
    },


    // 获取所有厂商列表
    getAllManufacturer(type,str){
      let params = {
        type: type  //类型 1厂商 2物业
      }
      this.$http.get(this.common.admin+'/admin/companyAllList',{params}).then(res => {
        if(res.code === 200){
          if(str==='query'){
            this.allManufacturerSearch = res.data;
          }
          // if(str==='dialog'){
          //   this.allManufacturer = res.data;
          // }
          
          // this.allManufacturer = [{id: 0, name: '车安堡自营'}, ...res.data];
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // 获取所有桩群
    getAllStation(val, type){
      let params = {
        cid: val,
        page: 1,
        size: 10000,
        created: 0  //0全部，1未配置的 //需求变更为不管有没有配置过都可选
        // created: type === 'add' ? 1 : 0  //0全部，1未配置的  
      };
      this.$http.post(this.common.admin + '/api/getGroupList',params).then(res => {
        if(res.code === 200){
          if(type === 'add'){
            // this.addStations = [{id: 0, name: '全部'}, ...res.data.list];
            this.addStations = [...res.data.list]; //去掉全部桩群
          }else if(type === 'edit'){
            this.addStations = res.data.list;
          }else{
            this.allStation = res.data.list;
          }
        }else{
          return this.$message.error(res.msg);
        }
      });
    },
    judgeManufacturer(){
      if(this.queryForm.cid === ''){
        return this.$message.error('请先选择所属厂商/物业');
      }
    },


    // 重置查询条件
    resetQuery() {
      this.queryForm = {
        page: 1,
        size: 20,
        type:null, //1厂商 2物业
        cid: '',
        status:'',
        start_date:'',
        end_date:'',
        pay_id:'',
      };      
      this.getTableList();
    },
    // 打开新建弹窗
    openDialog(){
      this.dialogVisible = true;
    },
    // 关闭新建弹窗
    closeDialog(){
      this.dialogVisible = false;
    },
    // 弹窗获取桩群
    goGetStatios(val, type){
      this.getAllStation(val, type ? type : 'add');
    },

    // 翻页
    changePage(page) {
      // this.page = page;
      this.queryForm.page = page;
      this.getTableList();
    },
    sizeChange(val){
      // this.size = val;
      this.queryForm.size = val;
      this.getTableList();
    },



    //修改账户状态
    handleStatus(row){
      let params = {
        id:row.id,
        status: row.status === 1?0:1,
      }
      let text = row.status == 1?'禁用' : '启用';
        this.$confirm(`此操作将${text}该账户, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$api.checkCompanyBank(params).then(res=>{
            if(res.code === 200){
              this.getTableList();
              this.$message.success(`${text}成功`);
            }
          });



        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    }




  },
};
</script>
<style lang="less" scoped>
.account{
  height: 100%;
  display: flex;
  flex-direction: column;

  .tableArea{
    flex: 1;
    min-height: calc(100% - 167px);
  }
  .pageFoot{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tongji{
      font-size: 14px;
    }
  }
}



</style>